(() => {
  if (customElements.get('size-chart-split')) {
    return;
  }

  const REGION_LABELS = {
    us: 'US',
    uk: 'UK',
    eu: 'EU',
    au: 'AU',
    fr: 'FR',
  };

  class SizeChartSplit extends HTMLElement {
    connectedCallback() {
      this.unit = 'in';
      this.region = 'us';

      this.unitButtons = this.querySelectorAll('[data-size-chart-unit]');
      this.regionSelect = this.querySelector('[data-size-chart-region]');
      this.panels = this.querySelectorAll('[data-size-chart-panel]');

      this.unitButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          this.setUnit(button.dataset.sizeChartUnit);
        });
      });

      if (this.regionSelect) {
        // Prevent change from bubbling to product-selector (would re-render and close the drawer)
        this.regionSelect.addEventListener('change', (event) => {
          event.stopPropagation();
          this.setRegion(this.regionSelect.value);
        });
        this.regionSelect.addEventListener('input', (event) => {
          event.stopPropagation();
        });
        this.regionSelect.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }

      this.setUnit(this.unit);
      this.setRegion(this.region);

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
          const section = this.closest('.shopify-section');

          if (!section || event.detail.sectionId !== section.id.replace('shopify-section-', '')) {
            return;
          }

          this.setUnit(this.unit);
          this.setRegion(this.region);
        });
      }
    }

    setUnit(unit) {
      if (!unit) {
        return;
      }

      this.unit = unit;

      this.unitButtons.forEach((button) => {
        const isActive = button.dataset.sizeChartUnit === unit;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.classList.toggle('is-active', isActive);
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.sizeChartPanel === unit;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });
    }

    setRegion(region) {
      if (!region) {
        return;
      }

      this.region = region;

      if (this.regionSelect && this.regionSelect.value !== region) {
        this.regionSelect.value = region;
      }

      const label = REGION_LABELS[region] || region.toUpperCase();

      this.querySelectorAll('.size-chart-split__region-heading').forEach((heading) => {
        heading.textContent = label;
      });

      this.querySelectorAll('.size-chart-split__region').forEach((cell) => {
        const value = cell.dataset[region];

        if (value) {
          cell.textContent = value;
        }
      });
    }
  }

  customElements.define('size-chart-split', SizeChartSplit);
})();
